import { render, staticRenderFns } from "./RecurringEvent.vue?vue&type=template&id=797f0d6a&scoped=true"
import script from "./RecurringEvent.vue?vue&type=script&lang=js"
export * from "./RecurringEvent.vue?vue&type=script&lang=js"
import style0 from "./RecurringEvent.vue?vue&type=style&index=0&id=797f0d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f0d6a",
  null
  
)

export default component.exports